import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { http, apiError } from "@/lib/api";

export default function OrderLookup() {
  const nav = useNavigate();
  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  async function lookup() {
    if (!orderId.trim() || !email.trim()) {
      toast.error("Enter both your order ID and email.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await http.get("/orders/lookup", {
        params: { order_id: orderId, email },
      });
      if (data.status === "paid" && data.download_token) {
        nav(`/download/${data.download_token}`);
      } else {
        toast.error(`Order found, but status is "${data.status}". Downloads unlock after payment.`);
      }
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="mx-auto max-w-md px-5 py-16 sm:px-8" data-testid="order-lookup-page">
        <h1 className="font-display text-3xl font-black text-[#1A0F1C]">Find my order</h1>
        <p className="mt-2 text-sm font-medium text-[#5C4A61]">
          Enter the order ID from your confirmation email and the email you used at checkout.
        </p>
        <div className="mt-8 space-y-4">
          <input
            value={orderId}
            onChange={(e) => setOrderId(e.target.value.toUpperCase())}
            placeholder="Order ID (e.g. 8FK2QX9P)"
            data-testid="lookup-order-id"
            className="w-full rounded-2xl border border-[#4A235A]/15 bg-white p-4 text-base font-medium uppercase outline-none focus:border-[#9B5DE5] focus:ring-4 focus:ring-[#F4D03F]/40"
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email used at checkout"
            data-testid="lookup-email"
            className="w-full rounded-2xl border border-[#4A235A]/15 bg-white p-4 text-base font-medium outline-none focus:border-[#9B5DE5] focus:ring-4 focus:ring-[#F4D03F]/40"
          />
          <button
            onClick={lookup}
            disabled={busy}
            data-testid="lookup-submit"
            className="inline-flex min-h-[56px] w-full items-center justify-center gap-2 rounded-full bg-[#4A235A] font-extrabold text-white transition-transform hover:-translate-y-1 disabled:opacity-60"
          >
            {busy ? <Loader2 className="animate-spin" size={20} /> : <Search size={20} />} Find my legend
          </button>
        </div>
      </div>
    </div>
  );
}
